import { render, staticRenderFns } from "./bath-tub.vue?vue&type=template&id=2b7631fe&scoped=true&"
import script from "./bath-tub.vue?vue&type=script&lang=js&"
export * from "./bath-tub.vue?vue&type=script&lang=js&"
import style0 from "./bath-tub.vue?vue&type=style&index=0&id=2b7631fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7631fe",
  null
  
)

export default component.exports